import axios from "axios";
//import {browserHistory} from "react-router";

// const
const ALGORITHM_ADD_INITIAL_DATA = "algorithmAdd/ALGORITHM_ADD_INITIAL_DATA";
const ALGORITHM_ADD_UPDATE_DATA = "algorithmAdd/ALGORITHM_ADD_UPDATE_DATA";
const ALGORITHM_ADD_STORE_ALGORITHM_CATEGORIES = "algorithmAdd/ALGORITHM_ADD_STORE_ALGORITHM_CATEGORIES";
const ALGORITHM_ADD_STORE_ALGORITHM_TYPES = "algorithmAdd/ALGORITHM_ADD_STORE_ALGORITHM_TYPES";
const ALGORITHM_ADD_TOGGLE_MODAL = "algorithmAdd/ALGORITHM_ADD_TOGGLE_MODAL";
const ALGORITHM_ADD_TOGGLE_LOADING = "algorithmAdd/ALGORITHM_ADD_TOGGLE_LOADING";
const ALGORITHM_ADD_TOGGLE_UPLOADING = "algorithmAdd/ALGORITHM_ADD_TOGGLE_UPLOADING";

const ALGORITHM_ADD_MODAL_SUCCESS_TITLE = "scenes_Algorithm_AlgorithmAdd_modal_success_title";
const ALGORITHM_ADD_MODAL_FAIL_TITLE = "scenes_Algorithm_AlgorithmAdd_modal_fail_title";
const ALGORITHM_ADD_MODAL_OK_LABEL = "scenes_Algorithm_AlgorithmAdd_modal_OK_label";
const ALGORITHM_ADD_MODAL_CANCEL_LABEL = "scenes_Algorithm_AlgorithmAdd_modal_cancel_label";
const ALGORITHM_ADD_MODAL_YES_LABEL = "scenes_Algorithm_AlgorithmAdd_modal_yes_label";
const ALGORITHM_ADD_MODAL_NO_LABEL = "scenes_Algorithm_AlgorithmAdd_modal_no_label";

const ALGORITHM_ADD_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmAdd_modal_submit_success_content";
const ALGORITHM_ADD_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Algorithm_AlgorithmAdd_modal_submit_fail_content";
const ALGORITHM_ADD_MODAL_AUDIT_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmAdd_modal_audit_success_content";
const ALGORITHM_ADD_MODAL_AUDIT_FAIL_CONTENT = "scenes_Algorithm_AlgorithmAdd_modal_audit_fail_content";

// reducer
export const algorithmAdd = (state = {
  loading: false,
  uploading: false,
  rowKey: 0,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  algorithmId: "",
  algorithmCategories: [],
  algorithmTypes: [],
  description: "",
  name: "",
  algorithmCategory: "",
  algorithmType: "",
  algorithmParameters: [],
  algorithmFile: [],
  algorithmFileId: "",
}, action) => {
  switch (action.type) {
    case ALGORITHM_ADD_INITIAL_DATA:
      return {
        ...state,
        loading: false,
        uploading: false,
        modalVisible: false,
        rowKey: 0,
        description: "",
        name: "",
        algorithmCategory: "",
        algorithmType: "",
        algorithmParameters: [],
        algorithmFile: [],
        algorithmFileId: "",
      };
    case ALGORITHM_ADD_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case ALGORITHM_ADD_STORE_ALGORITHM_CATEGORIES:
      return {
        ...state,
        algorithmCategories: action.data
      };
    case ALGORITHM_ADD_STORE_ALGORITHM_TYPES:
      return {
        ...state,
        algorithmTypes: action.data
      };
    case ALGORITHM_ADD_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case ALGORITHM_ADD_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case ALGORITHM_ADD_TOGGLE_UPLOADING:
      return {
        ...state,
        uploading: action.data
      };
    default:
      return state
  }
};

/**
 * initial data on load
 */
export const initialAlgorithmData = () => {
  return {
    type: ALGORITHM_ADD_INITIAL_DATA
  }
};

/**
 * update data based
 */
export const updateAlgorithmAddData = (data) => {
  return {
    type: ALGORITHM_ADD_UPDATE_DATA,
    data: data
  }
};

/**
 * get all algorithm categories
 */
export const getAlgorithmCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/getAlgorithmCategoryTree", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all algorithm categories
 */
export const storeAlgorithmCategories = (algorithmCategories) => {
  return {
    type: ALGORITHM_ADD_STORE_ALGORITHM_CATEGORIES,
    data: algorithmCategories
  }
};

/**
 * get all algorithm types
 */
export const getAlgorithmTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/algorithmTypes", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmTypes(response.data._embedded.algorithmTypes));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all algorithm types
 */
export const storeAlgorithmTypes = (algorithmTypes) => {
  return {
    type: ALGORITHM_ADD_STORE_ALGORITHM_TYPES,
    data: algorithmTypes
  }
};

/**
 * submit data
 */
export const createAlgorithm = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "post",
    url: "/api-algorithm/createAlgorithm",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "description": data.description,
      "name": data.name,
      "algorithmCategory": {"id": data.algorithmCategory},
      "algorithmType": {"code": data.algorithmType},
      "algorithmFileId": data.algorithmFileId,
      "parameters": data.parameters,
      "createById": data.createById,
      "createByName": data.createByName,
      "enabled": true
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200 && response.data) {
        console.info("success create new algorithm");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_ADD_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_ADD_MODAL_SUBMIT_SUCCESS_CONTENT,
          modalOk: ALGORITHM_ADD_MODAL_YES_LABEL,
          modalCancel: ALGORITHM_ADD_MODAL_NO_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            dispatch(updateAlgorithmStatus({
              algorithmId: response.data,
              algorithmStatus: "2"
            }));
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            this.props.history.push("/console/algorithm-list");
          }
        }));
      } else {
        console.error("fail to create new algorithm");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_ADD_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_ADD_MODAL_SUBMIT_FAIL_CONTENT,
          modalOk: ALGORITHM_ADD_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_ADD_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  ).catch(
    err => {
      console.error("fail to create new algorithm:", err);
      dispatch(toggleLoading(false));
      dispatch(toggleModal({
        modalVisible: true,
        modalTitle: ALGORITHM_ADD_MODAL_FAIL_TITLE,
        modalContent: ALGORITHM_ADD_MODAL_SUBMIT_FAIL_CONTENT,
        modalOk: ALGORITHM_ADD_MODAL_OK_LABEL,
        modalCancel: ALGORITHM_ADD_MODAL_CANCEL_LABEL,
        onOk: () => {
          dispatch(toggleModal({
            modalVisible: false
          }))
        },
        onCancel: () => {
          dispatch(toggleModal({
            modalVisible: false
          }))
        }
      }));
    }
  );
};

/**
 * update appStatus
 */
export const updateAlgorithmStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: "/api-algorithm/updateAlgorithmStatus",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.algorithmId,
      "algorithmStatus": {"code": data.algorithmStatus},
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success to update algorithm status");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_ADD_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_ADD_MODAL_AUDIT_SUCCESS_CONTENT,
          modalOk: ALGORITHM_ADD_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_ADD_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            this.props.history.push("/console/algorithm-list")
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            this.props.history.push("/console/algorithm-list")
          }
        }));
      } else {
        console.error("fail to update algorithm status");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_ADD_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_ADD_MODAL_AUDIT_FAIL_CONTENT,
          modalOk: ALGORITHM_ADD_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_ADD_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  ).catch(
    err => {
      console.error("fail to update algorithm status:", err);
      dispatch(toggleLoading(false));
      dispatch(toggleModal({
        modalVisible: true,
        modalTitle: ALGORITHM_ADD_MODAL_FAIL_TITLE,
        modalContent: ALGORITHM_ADD_MODAL_AUDIT_FAIL_CONTENT,
        modalOk: ALGORITHM_ADD_MODAL_OK_LABEL,
        modalCancel: ALGORITHM_ADD_MODAL_CANCEL_LABEL,
        onOk: () => {
          dispatch(toggleModal({
            modalVisible: false
          }))
        },
        onCancel: () => {
          dispatch(toggleModal({
            modalVisible: false
          }))
        }
      }));
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: ALGORITHM_ADD_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: ALGORITHM_ADD_TOGGLE_LOADING,
    data: show
  }
};

/**
 * toggle uploading
 */
export const toggleUploading = (show) => {
  return {
    type: ALGORITHM_ADD_TOGGLE_UPLOADING,
    data: show
  }
};
